import { Box } from '@valwin/facto/components';

type GoogleFormProps = {
  url: string;
  title: string;
};

export function GoogleForm({ url, title }: GoogleFormProps) {
  return (
    <Box asChild width="100%" height="65vh" border="0">
      <iframe src={url} title={title} />
    </Box>
  );
}
